import React, { useState, useMemo } from 'react';
import { authHeaders, axiosInstance, cleanText, formatRupiah, getSecondsLeft, isEmptyData, unixToDate, encodeValue } from '../../../../../utils/helper';
import { useSelector, useDispatch } from 'react-redux';
import { UFOODX_BASE_URL, uniqueID } from '../../../../../utils/constants';
import useNavigation from '../../../../../hook/useNavigation';
import { LoaderIcon } from '../../../../../utils/svg';
import { setPayment } from '../../../../../store/reducers/payment';
import { tableNumberAuto, setOrder } from '../../../../../store/reducers/order';
import moment from "moment-timezone";
import useToast from '../../../../../components/Toast';
import qs from 'qs';

const FooterAction = () => {
	const { showToast } = useToast();
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const { detail, orderTypeOptions } = useSelector((store) => store?.order);
	const data = detail?.request_post_datas;
	const user = useSelector((store) => store?.user);
	const [isLoading, setIsLoading] = useState(false);

	let isHidden = ['2', '3', '4', '5', '13', '14']?.includes(detail?.orderStatus);
	const paymentStatus = detail?.payment_status;
	if (cleanText(paymentStatus) === 'expired') {
		isHidden = true
	}

	const availabilityMap = useMemo(() => {
		if (!orderTypeOptions?.length) return {};

		return orderTypeOptions.reduce((acc, item) => {
			const key = cleanText(item?.av_name);
			acc[key] = item;
			return acc;
		}, {});
	}, [orderTypeOptions]);

	const company = useSelector((store) => store?.company);

	const handlePayNow = async () => {
		const paymentId = detail?.request_post_datas?.paymentReferenceID

		if (!paymentId) {
			showToast('error', 'Payment id cannot be empty');
			return;
		}

		const postData = new FormData();
		postData.append('session_token', null);
		postData.append('paymentReference', paymentId);
		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
        ...authHeaders().headers
			},
		};

		const url = `status-payment`;
		const detailPayment = await axiosInstance.post(url, postData, config);

		const data = detailPayment?.data?.data;
		const unixtime =
			typeof data?.expired_at === "string"
				? moment(data?.expired_at).unix()
				: data?.expired_at;
		const paymentData = {
			...data,
			session_token: detailPayment?.data?.session_token || null,
			date: moment().tz("Asia/Jakarta").format("YYYY-MM-DD HH:mm:ss"),
			expired_date: unixToDate(unixtime),
			timeLeft: getSecondsLeft(unixtime),
			qr_image_url: data?.qr_image_url || null
		};
		dispatch(setPayment(paymentData));

		navigate.push(`${UFOODX_BASE_URL}/payment`);
	}

	const handleCompletePickup = async (id = null) => {
		if (isEmptyData(id)) return;
		try {
			setIsLoading(true);
			const url = `/orders/completed-pickup`;
			const body = {
				unquieid: uniqueID,
				order_id: id,
			};
			const res = await axiosInstance.post(url, JSON.stringify(body), {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user?.token}`,
				},
			});
			if (res?.status === 200) {
				window.location.reload()
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	}

	const handleRemoveCart = async () => {
		console.log('handleRemoveCart');
		try {
			const postData = {
				unquieid: uniqueID,
			};
			const res = await axiosInstance.post(`cart/removeCart`, qs.stringify(postData));
			return res;
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleOrderAgain = async () => {
		console.log('handleOrderAgain');
		try {
			const removeCart = await handleRemoveCart();
			if (removeCart?.data?.status !== 'ok') {
				return;
			}
			const selectedAvailability = availabilityMap[cleanText(detail?.orderType)];
			//set selected order type
			dispatch(setOrder({ selectedOrderType: selectedAvailability }));

			//check dine or not
			if (cleanText(detail?.orderType) === 'dinein') {
				//create number dine in
				dispatch(
					tableNumberAuto({
						companyId: Number(company?.companyID),
						outletId: Number(data?.storeID),
						brandId: Number(data?.brandID),
					})
				);
			}
			const postData = {
				unquieid: uniqueID,
				orderID: encodeValue(detail?.order_primary_id),
			};
			const res = await axiosInstance.post(`orders/orderAgain`, qs.stringify(postData));
			if (res?.data?.status === 'ok') {
				navigate.push(`${UFOODX_BASE_URL}/summary`, {}, true);
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	return (
		<>
			{cleanText(detail?.orderType) === 'pickup' && detail?.orderStatus === '13' && (
				<button id='order_history_reorder_detail' className='w-full button text-sm font-semibold mt-0 bg-[var(--rose-violet)] border-[var(--rose-violet)] hover:bg-[var(--rose-violet)]' onClick={() => handleCompletePickup(detail?.order_primary_id)}>
					{isLoading ? (
						<div className='flex justify-center items-center w-full'>
							<LoaderIcon />
						</div>
					) : (
						'Sudah Diambil'
					)}
				</button>
			)}

			<div className={`w-full fixed bottom-0 left-1/2 -translate-x-1/2 max-w-3xl bg-transparent z-[6] p-4 bg-white ${isHidden && 'hidden'}`}>
				<div onClick={() => handlePayNow()} className={`w-full bg-[var(--rose-violet)] text-white flex justify-between font-normal text-sm p-3 border-0 items-center rounded-md`}>
					<span>Bayar dan pesan</span>
					<span className='text-sm'>{formatRupiah(detail?.totalAmount || 0)}</span>
				</div>
			</div>

			{(detail?.orderStatus === '4' || detail?.orderStatus === '5') && (
				<div>
					<div onClick={() => handleOrderAgain()} className={`w-full button text-sm font-semibold mt-0 bg-[var(--rose-violet)] border-[var(--rose-violet)] hover:bg-[var(--rose-violet)]`}>
						<span>Pesan Kembali</span>
					</div>
				</div>
			)}
		</>
	);
};

export default FooterAction;
